import { render } from "./LoaderDots.vue?vue&type=template&id=f7b5a026&scoped=true"
import script from "./LoaderDots?vue&type=script&lang=js"
export * from "./LoaderDots?vue&type=script&lang=js"

import "./LoaderDots.scss?vue&type=style&index=0&id=f7b5a026&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f7b5a026"]])

export default __exports__